import { beadCss } from "./colors";

export interface FlightOptions {
  readonly color: string;
  readonly from: DOMPoint;
  readonly to: DOMPoint;
  readonly duration?: number;
  readonly delay?: number;
  readonly reverse?: boolean;
}

function wait(milliseconds: number): Promise<void> {
  return new Promise((resolve) => window.setTimeout(resolve, milliseconds));
}

export async function flyBead(
  layer: HTMLElement,
  options: FlightOptions,
): Promise<void> {
  const { color, from, to, duration = 320, delay = 0, reverse = false } = options;
  if (delay > 0) {
    await wait(delay);
  }

  const layerRect = layer.getBoundingClientRect();
  const bead = document.createElement("div");
  bead.className = "flight-bead";
  bead.style.cssText = `${beadCss(color)};left:${from.x - layerRect.left}px;top:${from.y - layerRect.top}px`;
  layer.append(bead);

  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const arc = reverse ? -Math.min(92, Math.abs(dy) * 0.2 + 34) : -Math.min(72, Math.abs(dy) * 0.16 + 26);
  const animation = bead.animate(
    [
      { transform: "translate(-50%, -50%) scale(1.18)", offset: 0 },
      { transform: `translate(calc(-50% + ${dx * 0.48}px), calc(-50% + ${dy * 0.42 + arc}px)) scale(1.06)`, offset: 0.48 },
      { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy + 5}px)) scale(.92)`, offset: 0.88 },
      { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(1)`, offset: 1 },
    ],
    { duration, easing: "cubic-bezier(.22,.72,.2,1)", fill: "forwards" },
  );
  await animation.finished;
  bead.remove();
}
